import FormPage from "./Form";
import ListPage from "./List";

export default function ProfilesPage(props: any) {
  return (
    <div className="content_page">
      {props.action && props.action == "list" && (
        <ListPage action={props.action} />
      )}

      {props.action && ["create", "edit"].includes(props.action) && (
        <FormPage action={props.action} />
      )}
    </div>
  );
}
